<div class="text-center mt-5 pb-2">Copyright (C) 2023 UNLC All rights reserved.
  <a href="https://unlc.rsvsys.jp/info/privacy" target="_blank">Privacy Policy</a>&nbsp;&nbsp;&nbsp;
  <a href="https://unlc.rsvsys.jp/info/term" target="_blank">Terms Of Use</a>
</div>
